import {
	FORMULA_OPERATIONS as FP,
	GeometryTypes,
	PathOperationTypes,
	ShapeType,
} from "../widgets/interfaces/model/enumerations/index";
import { IPresetGeometry } from "../widgets/interfaces/model/geometry/PresetGeometry";

/**
 * Heart preset definition
 * ECMA-376, Third Edition, Part 1 - Fundamentals And Markup Language Reference
 * /OfficeOpenXML-DrawingMLGeometries/presetShapeDefinitions.xml
 */
export const heart: IPresetGeometry = {
	// ahLst: [],
	// avList: [],
	gdLst: [
		{ name: "dx1", fmla: { operation: FP.MultiplyDivide, operands: ["w", 49, 48] } },
		{ name: "dx2", fmla: { operation: FP.MultiplyDivide, operands: ["w", 10, 48] } },
		{ name: "x1", fmla: { operation: FP.AddSubtract, operands: ["hc", 0, "dx1"] } },
		{ name: "x2", fmla: { operation: FP.AddSubtract, operands: ["hc", 0, "dx2"] } },
		{ name: "x3", fmla: { operation: FP.AddSubtract, operands: ["hc", "dx2", 0] } },
		{ name: "x4", fmla: { operation: FP.AddSubtract, operands: ["hc", "dx1", 0] } },
		{ name: "y1", fmla: { operation: FP.AddSubtract, operands: ["t", 0, "hd3"] } },
		{ name: "il", fmla: { operation: FP.MultiplyDivide, operands: ["w", 1, 6] } },
		{ name: "ir", fmla: { operation: FP.MultiplyDivide, operands: ["w", 5, 6] } },
		{ name: "ib", fmla: { operation: FP.MultiplyDivide, operands: ["h", 2, 3] } },
	],
	pathLst: [{
		operations: [
			{ pt: { x: "hc", y: "hd4" }, type: PathOperationTypes.MOVE_TO },
			{
				pts: { 0: { x: "x3", y: "y1" }, 1: { x: "x4", y: "hd4" }, 2: { x: "hc", y: "b" } },
				type: PathOperationTypes.CUBIT_BEZ_TO,
			},
			{
				pts: { 0: { x: "x1", y: "hd4" }, 1: { x: "x2", y: "y1" }, 2: { x: "hc", y: "hd4" } },
				type: PathOperationTypes.CUBIT_BEZ_TO,
			},
			{ type: PathOperationTypes.CLOSE },
		],
	}],
	presetShape: ShapeType.heart,
	rect: { l: "il", t: "hd4", r: "ir", b: "ib" },
	type: GeometryTypes.PRESET,
};

/**
 * Microsoft open xml preset definition (for Reference purpose only)
 * <heart>
 *   <gdLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <gd name="dx1" fmla="* / w 49 48" />
 *     <gd name="dx2" fmla="* / w 10 48" />
 *     <gd name="x1" fmla="+- hc 0 dx1" />
 *     <gd name="x2" fmla="+- hc 0 dx2" />
 *     <gd name="x3" fmla="+- hc dx2 0" />
 *     <gd name="x4" fmla="+- hc dx1 0" />
 *     <gd name="y1" fmla="+- t 0 hd3" />
 *     <gd name="il" fmla="* /  w 1 6" />
 *     <gd name="ir" fmla="* / w 5 6" />
 *     <gd name="ib" fmla="* / h 2 3" />
 *   </gdLst>
 *   <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <cxn ang="3cd4">
 *       <pos x="hc" y="hd4" />
 *     </cxn>
 *     <cxn ang="cd4">
 *       <pos x="hc" y="b" />
 *     </cxn>
 *   </cxnLst>
 *   <rect l="il" t="hd4" r="ir" b="ib" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main" />
 *   <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <path>
 *       <moveTo>
 *         <pt x="hc" y="hd4" />
 *       </moveTo>
 *       <cubicBezTo>
 *         <pt x="x3" y="y1" />
 *         <pt x="x4" y="hd4" />
 *         <pt x="hc" y="b" />
 *       </cubicBezTo>
 *       <cubicBezTo>
 *         <pt x="x1" y="hd4" />
 *         <pt x="x2" y="y1" />
 *         <pt x="hc" y="hd4" />
 *       </cubicBezTo>
 *       <close />
 *     </path>
 *   </pathLst>
 * </heart>
 */
